import { render, staticRenderFns } from "./DialogQuestion.vue?vue&type=template&id=3de31726"
import script from "./DialogQuestion.vue?vue&type=script&lang=js"
export * from "./DialogQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports